// Remembers the visitor's last browse search for the tab's lifetime so that
// "Back to listings" on a property page restores it. A plain /properties link
// would drop the filters whenever the visitor arrived through a listing URL,
// opened the listing in the same tab from a shared search, or reloaded.
import { pickBrowseParams } from "@/lib/browseFilters";

export const LAST_BROWSE_SEARCH_KEY = "msth_last_browse_search_v1";

/** Store the browse part of the current URL (nothing when the search is empty). */
export const rememberBrowseSearch = (params: URLSearchParams): void => {
  try {
    const qs = pickBrowseParams(params).toString();
    if (qs) sessionStorage.setItem(LAST_BROWSE_SEARCH_KEY, qs);
    else sessionStorage.removeItem(LAST_BROWSE_SEARCH_KEY);
  } catch {
    /* storage unavailable (private mode, quota): back links go to /properties */
  }
};

/** Where "Back to listings" should go: the remembered search, else /properties. */
export const lastBrowsePath = (): string => {
  try {
    const qs = sessionStorage.getItem(LAST_BROWSE_SEARCH_KEY);
    return qs ? `/properties?${qs}` : "/properties";
  } catch {
    return "/properties";
  }
};
